<template>
    <AdminPageInner v-if="loaded" :breadcrumbs="breadcrumbs">
        <template #heading>Course Sessions</template>
        <template #links>
            <router-link
                v-if="$can('create', 'CourseSessionGroup')"
                :to="{name: 'admin.courses.session-groups.create', params: {courseId: $route.params.courseId}}">
                Create
            </router-link>
        </template>
        <PaginationWrapper ref="pagination" :rows="rows" :constraints="constraints" :meta="meta">
            <CourseSessionGroupsDataComponent
                class="w-full mt-6"
                :data="rows"
                :initialSort="initialSort"
                @sort="onSort"
                @remove:sessionGroup="onRemoveSessionGroup"/>
        </PaginationWrapper>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner.vue";
import PaginationWrapper from "@/Components/Layout/PaginationWrapper.vue";
import PaginationPage from "@/Mixins/PaginationPage";
import CourseSessionGroupsDataComponent from "@/Pages/Admin/CourseSessionGroups/Components/DataComponent"
import CalendarFormat from "@/Components/CalendarFormat";
import dayjs from "dayjs";

export default {

    name: "courseSessionGroupIndexPage",

    mixins: [PaginationPage],

    data() {
        return {
            course: {}
        };
    },

    components: {
        AdminPageInner,
        PaginationWrapper,
        CourseSessionGroupsDataComponent,
        CalendarFormat
    },

    methods: {
        setData(data) {
            PaginationPage.methods.setData.call(this, data.sessionGroups);
            if (data.course) {
                this.course = data.course;
            }
        },
        onRemoveSessionGroup() {
            this.$router.push({
                name: this.$route.name,
                query: _.assign({}, this.$route.query, {t: dayjs().unix()})
            });
        }
    },

    computed: {
        breadcrumbs() {
            return [
                {
                    label: 'Admin', to: {name: 'admin'}
                },
                {
                    label: 'Courses', to: {name: 'admin.courses.index'}
                },
                {
                    label: `${this.course.title || 'Course'}`,
                    to: {name: 'admin.courses.show', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: `Session Groups`, to: {name: this.$route.name, params: this.$route.params}
                },
            ];
        },
    },

    async beforeRouteEnter(to, from, next) {

        const data = await fetchAllData(to);
        next(vm => vm.setData(data));
    },

    async beforeRouteUpdate(to, from) {

        let data = {};

        if (to.params.courseId !== from.params.courseId) {
            data = fetchAllData(to);
        } else {
            data.sessionGroups = (await fetchSessionGroups(to)).data;
        }

        this.setData(data);
    },
};

const fetchAllData = async to => {

    const data = await Promise.all([
        fetchSessionGroups(to),
        axios.get(route('api.courses.show', to.params.courseId), {params: to.query}),
    ])

    return {
        sessionGroups: data[0].data,
        course: data[1].data
    };
}

const fetchSessionGroups = async (to) => {
    return axios.get(route('api.course-session-groups.index'), {
        params: Object.assign(to.query, {course_id: to.params.courseId})
    });
}

</script>
